// extracted by mini-css-extract-plugin
export default {"resizeNone":"LabActionDetailsPopup_resizeNone__AIiO8","customWidth95":"LabActionDetailsPopup_customWidth95__Dz3hJ"};